import PROCTORING_TYPE from '../enums/proctoringType'

const PROCTORING_TYPE_CONFIG = {
    [PROCTORING_TYPE.NO_PROCTORING]: {
        title: 'Unproctored',
    },
    [PROCTORING_TYPE.PHYSICAL_PROCTORING]: {
        title: 'Physical',
    },
    [PROCTORING_TYPE.REMOTE_PROCTORING]: {
        title: 'Remote',
    },
}

export default PROCTORING_TYPE_CONFIG
